import React, { useState, useEffect, useCallback } from 'react';
import { DefaultService } from '../generated-api';
import ChatWidget from '../components/rules/ChatWidget';

interface ChatPageProps {
  gameId: string;
  gameName: string;
}

const ChatPage: React.FC<ChatPageProps> = ({ gameId, gameName }) => {
  const [hasRules, setHasRules] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const loadRules = useCallback(async () => {
    try {
      setIsLoading(true);
      const rulesData = await DefaultService.getGameRulesGamesGameIdRulesGet({ gameId });
      setHasRules(rulesData.hasRules);
    } catch (error) {
      console.error('Failed to load rules:', error);
    } finally {
      setIsLoading(false);
    }
  }, [gameId]);

  useEffect(() => {
    loadRules();
  }, [loadRules]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  return (
    <ChatWidget
      gameId={gameId}
      gameName={gameName}
      hasRules={hasRules}
    />
  );
};

export default ChatPage;
